//  FMSDJ-2 Divyani 9/4/2021
//  FMSDJ-14 vidit 19/04/2021
//  FMSDJ-2 Divyani 19/4/2021
//  FMSDJ-2 Divyani 20/4/2021
// FMSDJ-2 riddhi 21/4/2021
// FMSDJ-2 riddhi 23/4/2021 
// FMSDJ-4 ridhi 28/04/2021
// FMSDJ-17 ridhi 29/04/2021
// FMSDJ-19 riddhi 27/5/2021 
$( document ).ready(function() {
  var window_height = $(window).height();
  var headeheight = $('header').outerHeight();
  var footeheight = $('footer').height();
  var sub_total = headeheight + footeheight;
  var total_height = window_height - sub_total;
  $('#recharge-te').css('min-height', total_height);
  $(window).resize(function(){
    var window_height = $(window).height();
    var headeheight = $('header').outerHeight();
    var footeheight = $('footer').height();
    var sub_total = headeheight + footeheight;
    var total_height = window_height - sub_total;
    $('#recharge-te').css('min-height', total_height);
  });

  $('.product_slider').slick({
    dots: true,
    infinite: true,    
    slidesToShow: 2,     
    responsive: [      
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          arrows:false

        }
      },{
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          arrows:false
        }
      }
    ]
  });

  $('.upsellcollection-slider').slick({
    dots: true,
    infinite: false,    
    slidesToShow: 4,     
    responsive: [      
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3         
        }
      },
      {
        breakpoint: 790,
        settings: {
          slidesToShow: 2,
          arrows:false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          arrows:false
        }
      }
    ]
  });

  if($(window).width() < 871){
    $('.tt-product-single-img').slick({  
      slidesToShow: 1,
      arrows:false
    });
  }

  setTimeout(function(){ 
    $('.tt-carousel-products-js').slick('unslick')
    $('.tt-carousel-products-js').slick({
      dots: true,
      infinite: false,
      slidesToShow: 4,
      responsive: [      
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 790,
          settings: {
            slidesToShow: 2            
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            arrows:false
          }
        }
      ]
    });
  }, 2000);

  $('.nav-link').on('click', function(){

    var slider_div = $($(this).attr('href')).children();
    setTimeout(function(){    
      $(slider_div).slick('unslick')
      $(slider_div).slick({
        dots: true,
        infinite: false,
        arrows:true,
        slidesToShow: 4,
        responsive: [      
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 790,
            settings: {
              slidesToShow: 2              

            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              arrows:false
            }
          }
        ]
      });
    }, 500);
  });

  // Accordion - JavaScript
  $('.contentBx').on('click', function(){
    $('.contentBx').removeClass('active');
    $(this).addClass('active')
  });

  //Slick_Slider - Client Sys
  $('.one-time').slick({
    infinite: true,
    arrows: false,
    slidesToShow:4,
    slidesToScroll: 1,
    autoplay: false,
    responsive: [
      {
        breakpoint: 870,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1
        }
      }]
  });

  //Banner button 
  $(".down-arrow").click(function(event) {
    event.preventDefault();
    $("html, body").animate({ scrollTop: "+=650px" }, 1500);
  });

  // login popup
  $(".login-pop-up").on("click", function () {
    var modal = $(this).data("modal");
    $(modal).show();
    $('body').toggleClass('model_open');
  });
  $('.popup_close ').click(function () {
    $('.modal').hide();
    $('body').removeClass('model_open');
  });
  $(".modal").on("click", function (e) {
    var className = e.target.className;
    if (className === "modal") {
      $(this).closest(".modal").hide();
      $('body').removeClass('model_open');
    }
  });

  $('.customer_popup_link').on('click',function(){    
    var data_id = $(this).data('id');
    $(this).parent().parent().parent().hide();
    if(data_id == 'regiater'){ 
      $(this).parent().parent().parent().next().show();

    }else {
      $(this).parent().parent().parent().prev().show();
    }
  });

  $('.side-bar-menu .mmpanel  .mega-menu li').each(function(){
    var img_class = $(this).children().text().toLowerCase();
    $(this).children().addClass(img_class+'_img');
  });

  // password vidiblity toggle login
  $('.login-psswd').on('click', function() {
    if ($('.input-psswd').attr('psswd-shown') == 'false') {
      $('.input-psswd').removeAttr('type');
      $('.input-psswd').attr('type', 'text');
      $('.input-psswd').removeAttr('psswd-shown');
      $('.input-psswd').attr('psswd-shown', 'true');
    }else {
      $('.input-psswd').removeAttr('type');
      $('.input-psswd').attr('type', 'password');
      $('.input-psswd').removeAttr('psswd-shown');
      $('.input-psswd').attr('psswd-shown', 'false');
    }
  });

  // password vidiblity toggle Register
  $('.register-psswd').on('click', function() {
    if ($('.reg-input-psswd').attr('psswd-shown') == 'false') {
      $('.reg-input-psswd').removeAttr('type');
      $('.reg-input-psswd').attr('type', 'text');
      $('.reg-input-psswd').removeAttr('psswd-shown');
      $('.reg-input-psswd').attr('psswd-shown', 'true');
    }else {
      $('.reg-input-psswd').removeAttr('type');
      $('.reg-input-psswd').attr('type', 'password');
      $('.reg-input-psswd').removeAttr('psswd-shown');
      $('.reg-input-psswd').attr('psswd-shown', 'false');
    }
  });

  $('.mm-next-level').on('click',function(){
    var l_text = $(this).text();
    $('.mm-prev-level').text(l_text);
  });

  // dropdown close
  $('.login-close-btn').on('click', function() {
    $('.login-popup-open').css('display','none');
    $('.tt-account').removeClass('active');
    $('body').removeClass('tt-popup-dropdown');    
  });

  var header_height = $('.tt-mobile-header').outerHeight();
  var window_height = $(window).height() - header_height;
  $('.page404').css('min-height',window_height);
  $(window).resize(function(){
    var header_height = $('.tt-mobile-header').outerHeight();
    var window_height = $(window).height() - header_height;
    $('.page404').css('min-height',window_height);
  });

  $('.tt-search-input').keyup(function(){  
    var term = $(this).val(),      
        item_title = $('#search_item_title').val().toLowerCase(),
        item_array = item_title.split(','),
        search_val = '';
    $.each(item_array, function(index, value){           
      if(term.length > 2){  
        if( value.includes(term) ){             
          var term_val =  value.split(' ');   
          $.each(term_val, function(index, t_value){					
            if( t_value.includes(term) ){             
              if(t_value.substr(0, 3) == term.substr(0, 3)){
                search_val = t_value;
              }
            }
          });
          return false; // breaks
        }
      }
    });    
    if (search_val == ''){ 
      $(this).next('.tt-search-value').text(term);
    }else{       
      $(this).next('.tt-search-value').text(search_val);         	       
    }   
    if($('.search-results').children().length > 0){
      $('.tt-mobile-header .tt-search .tt-dropdown-menu .search_btn').addClass('show_btn');
    }else{
      $('.tt-mobile-header .tt-search .tt-dropdown-menu .search_btn').removeClass('show_btn');
    }
  });


  $('.user_logout svg').on("click", function (e) {
    $('.user_account').slideToggle();
    $('.search-bar').hide(); 
    e.preventDefault();
    e.stopPropagation();
  });

  $('.user_account').on("click", function (e) {
    e.stopPropagation();
  });

  $(document).on('click',function(){    
    $('.user_account').hide();   
    if($('.tt-account.tt-dropdown-obj').hasClass('active')){
      $('body').addClass('tt-popup-dropdown'); 
    }else{
      $('body').removeClass('tt-popup-dropdown'); 
    }
  }); 

  $('.cart-order-summery').on("click", function () {
    $(this).next().slideToggle();
    $(this).parent().toggleClass('toggle_show');
  });  


  $("ul.tabs li").click(function() {	      
    var activeTab = $(this).attr("rel");
    $(".tab_content").removeClass("active_content");	
    $("#"+activeTab).addClass("active_content");
    $("ul.tabs li").removeClass("active");
    $(this).addClass("active");	  
  });

  if($('.upsellcollection-slider .slick-slide ').length < 4){
    $('.upsellcollection-slider').addClass('slide-center');
  }

  $('.image-desktop-blocks .img-text-block img').css('height',$('.image-desktop-blocks-height img').height());
  $('.mobile_image-blocks .img-text-block img').css('height',$('.mobile_image-blocks .image-blocks-height img').height());

  
  $('.Cartoverlay').on("click", function () {
   $( ".js-drawer-close" ).trigger('click');
  });
  
  $('.cart__section form').css('height',$(window).height());
  $(window).resize(function(){
    $('.cart__section form').css('height',$(window).height());
  });

//   $('.tt-search .tt-dropdown-menu').on("click", function (e) {
//     e.stopPropagation();
//   });
//   $(".tt-dropdown-toggle").on("click", function (e) { debugger;
//     e.preventDefault();
//     e.stopPropagation();  
//   });
//   $(document).on("click", function () {
//     $(' .tt-search').removeClass('active');
//   });
  
  var returnedUserR = sessionStorage.getItem("returneduser");  
  if (!returnedUserR) {
    $('#shpflt-regionalModal').css('display','flex');
    $('.shpflt-closeregional').on('click',function(e){
       e.preventDefault();
    e.stopPropagation();  
      $('#shpflt-regionalModal').hide();
      sessionStorage.setItem("returneduser", "returned");
    });
    
    $('.shpflt-regional-popup,.admin-bar,#cookiesModal,.needsclick[formtype="POPUP"]').on("click", function (e) {
      e.stopPropagation();
    });
    $(document).on("click", function () {
      $('#shpflt-regionalModal').hide();
      sessionStorage.setItem("returneduser", "returned");
    });
    
  }

  $('.subscription-dropdown').on('click',function(){
   $(this).toggleClass('subscription-active');
  });
  
  if( $('#rc_container').length == 0 ){
   $('.subscription-dropdown').hide();
  }
 
  $(document).on('change', '.cart__note .switch input', function() {  
     if ($(this).is(':checked')) {
      $(this).parents('.cart__note').find('.form-default').show();
       localStorage.setItem("note_checked", "checked");
     }else{
     $(this).parents('.cart__note').find('.form-default').hide();
     }
  }); 

  if($('body').hasClass('pagecart')){
    if(localStorage.getItem("note_checked") == "checked"){
      $('.cart__note .switch input').prop('checked','true');
      $('.cart__note').find('.form-default').show();
      localStorage.setItem("note_checked", "");
    }
  }

  $('.tt-newsletter .form-control').keyup(function() {   
    if($(this).val().length > 0 ){
      $(this).parent().addClass('focus');
    }else{
      $(this).parent().removeClass('focus');
    }
  });
  setTimeout(function(){
  
    $('.tt-newsletter form.needsclick input[type=email]').keyup(function() {   
      if($(this).val().length > 0 ){
        $(this).parents('form.needsclick').addClass('focus');
      }else{
        $(this).parents('form.needsclick').removeClass('focus');
      }
    }); 

    $(".tt-newsletter form.needsclick input[type=email]").hover(function(){ 
      $(this).parents('form.needsclick').addClass('hover');
    }, function(){
      $(this).parents('form.needsclick').removeClass('hover');
    });
  }, 3000);
  
});


/* $(document).ready(function() { 
  $('.videomodalbox-main , .videomodalbox-icon').click(function(){
   	//alert("y"); 
    $('.videomodalbox-main , .videomodalbox-icon').hide();
    //$("#iframe").load(location.href + " #iframe");
    $('.video-wrapper').css("display", "block");
   // 
    
  });
 });*/
